﻿export enum TextFilterOption {
    StartsWith = 0,
    EndsWith = 1,
    Contains = 2
}